export const SIDEBAR_WIDTH = 260;
